export class UserInfo {
	email: string;
	emailDomain: string;
	fullName: string;
	firstName: string;
	lastName: string;
	isLoggedIn: boolean;
	token: string;
	refresh_token: string;
	userName: string;
	personPhotoUrl: string;
	userID: any;
	personID: any;
	UserLevelID: any;
	c_date: any;
	token_expiration: any;
	HasClassRoomAttendanceAccess: any;
	HasPrintAccess: any;
	HasVisitorAccess: any;
	ApplicationItemID: string;
	SSOLogoutLink: string;
}
